import { svgSpriteDirectivePlugin } from 'vue-svg-sprite'

function requireAll(r) {
   
  r.keys().forEach(r);
}
 
requireAll(require.context('@ui/styles/src/img/icons/', true, /\.svg$/));

export { svgSpriteDirectivePlugin }

